import { useState, useRef } from 'react';
import StyledWrapper from './style';
import { ClickAwayListener, Grow, Paper, Popper, MenuItem, MenuList } from '@mui/material';
import EllipsisIcon from '../../assets/customIcons/ellipsis';
import ApplicationDeleteModal from '../ApplicationDeleteModal/ApplicationDeleteModal';
import ApplicationReassignmentModal from '../ApplicationReassignmentModal/ApplicationReassignmentModal';

const ApplicationActions = ({
	projectTitle,
	handleAlert,
	handleApplicationListAlert,
	isDeletable,
	isReassignable,
	refetchNavInfo,
	setJustDeletedApplication
}) => {
	const [menuOpen, setMenuOpen] = useState(false);
	const [deleteModalOpen, setDeleteModalOpen] = useState(false);
	const [reassignModalOpen, setReassignModalOpen] = useState(false);
	const anchorRef = useRef(null);

	const hasMenuItems = isDeletable || isReassignable;

	const handleMenuToggle = () => {
		setMenuOpen((prevMenuOpen) => !prevMenuOpen);
	};
	const handleMenuClose = (event) => {
		if (anchorRef.current && anchorRef.current.contains(event.target)) {
			return;
		}
		setMenuOpen(false);
	};

	const handleOpenDeleteModal = () => {
		setDeleteModalOpen(true);
	};
	const handleCloseDeleteModal = () => {
		setDeleteModalOpen(false);
	};

	const handleOpenReassignModal = () => {
		setReassignModalOpen(true);
	};
	const handleCloseReassignModal = () => {
		setReassignModalOpen(false);
	};

	return (
		<StyledWrapper.ApplicationActionsContainer>
			<StyledWrapper.EllipsisButton
				ref={anchorRef}
				aria-label="actions-dropdown"
				onClick={handleMenuToggle}
				disabled={!hasMenuItems}
			>
				<EllipsisIcon />
			</StyledWrapper.EllipsisButton>
			<Popper
				sx={{
					zIndex: 1202
				}}
				open={menuOpen}
				anchorEl={anchorRef.current}
				placement="bottom-start"
				transition
				disablePortal
			>
				{({ TransitionProps, placement }) => (
					<Grow
						{...TransitionProps}
						style={{
							transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom'
						}}
					>
						<Paper>
							<ClickAwayListener onClickAway={handleMenuClose}>
								<MenuList id="split-button-menu" autoFocusItem>
									{isDeletable && (
										<MenuItem onClick={handleOpenDeleteModal}>Delete Application</MenuItem>
									)}
									{isReassignable && (
										<MenuItem onClick={handleOpenReassignModal}>Reassign Application</MenuItem>
									)}
								</MenuList>
							</ClickAwayListener>
						</Paper>
					</Grow>
				)}
			</Popper>
			{/* Modals */}
			<ApplicationDeleteModal
				projectTitle={projectTitle}
				isOpen={deleteModalOpen}
				handleClose={handleCloseDeleteModal}
				handleAlert={handleAlert}
				handleApplicationListAlert={handleApplicationListAlert}
				setJustDeletedApplication={setJustDeletedApplication}
			/>
			<ApplicationReassignmentModal
				isOpen={reassignModalOpen}
				handleClose={handleCloseReassignModal}
				handleAlert={handleAlert}
				refetchNavInfo={refetchNavInfo}
			/>
		</StyledWrapper.ApplicationActionsContainer>
	);
};

export default ApplicationActions;
